import { TransactionStatusEnum } from 'config/types/transaction'
import useModal from 'hooks/useModal'
import { RowMiddle } from 'layout/Components/Row'
import React, { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalProps } from 'UIKit/Modal'
import Text, { TextProps } from 'UIKit/Text'
import { TransactionStatus } from 'views/Profile/Transactions/components/styled'
import {
  PAYMENT_MODAL_THEME,
  PaymentChevronRightIcon,
  PaymentInputContainer,
  PaymentLabel,
  StylePaymentModal,
} from '../styles'

const statuses = [TransactionStatusEnum.Failed, TransactionStatusEnum.Pending, TransactionStatusEnum.Succeeded]

const PaymentHistoryFilterModal: React.FC<
  ModalProps<{
    status: TransactionStatusEnum
    onSelect?: (status: TransactionStatusEnum) => void
  }>
> = ({ data: { onSelect, status }, onDismiss }) => {
  const { t } = useTranslation()

  const options = useMemo(
    () => (status ? [null, ...statuses.filter((item) => item !== status)] : statuses),
    [statuses, status],
  )

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Filter')} />
      <ModalBody>
        {options.map((opt) => (
          <FilterOptionItem
            status={opt}
            onSelect={(v) => {
              onSelect(v)
              onDismiss()
            }}
          />
        ))}
      </ModalBody>
    </StylePaymentModal>
  )
}

const FilterOptionItem = ({
  status,
  onSelect,
}: {
  status: TransactionStatusEnum
  onSelect?: (status: TransactionStatusEnum) => void
} & Omit<TextProps, 'onSelect'>) => {
  return (
    <Text
      py="10px"
      fontSize="var(--pm-label-size)"
      color="var(--pm-label-color)"
      onClick={() => onSelect && onSelect(status)}
    >
      {status ? (
        <TransactionStatus status={status} fontSize="1em" />
      ) : (
        <Text fontSize="1em" color="currentColor">
          <Trans>All Status</Trans>
        </Text>
      )}
    </Text>
  )
}

export const SelectedStatusItem: React.FC<{
  status: TransactionStatusEnum
  onSelect?: (status: TransactionStatusEnum) => void
  disabled?: boolean
}> = ({ status, onSelect, disabled }) => {
  const [onPresent] = useModal(PaymentHistoryFilterModal)

  return (
    <PaymentInputContainer
      justifyContent="space-between"
      p="12px"
      onClick={() =>
        onPresent({
          onSelect,
          status,
        })
      }
    >
      <PaymentLabel color="var(--pm-text-trigger-color)">
        <Trans>Status</Trans>
      </PaymentLabel>
      <RowMiddle gap="8px">
        <FilterOptionItem status={status} />

        {!disabled && onSelect && (
          <RowMiddle width={12}>
            <PaymentChevronRightIcon />
          </RowMiddle>
        )}
      </RowMiddle>
    </PaymentInputContainer>
  )
}

export default PaymentHistoryFilterModal
